import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class AssetsService {
  private readonly apiService = inject(BaseApiService);

  async getAssets(limit: number, offset: number, search: string, order: TableSort | null, locationId: string, showInactive: boolean) {
    const body = {
      offset: offset,
      limit: limit,
      search: search,
      sort: JSON.stringify(order),
      locationId: locationId == '0' || !locationId ? null : locationId,
      showInactive: showInactive
    };
    return await this.apiService.post('/assets/list', body);
  }

  async getServiceHistory(id: string) {
    return this.apiService.get(`/assets/${id}/service-history`);
  }

  async getAllAssets() {
    return this.apiService.get(`/assets`);
  }

  async getAllAssetsByLocation(locationId: string) {
    return this.apiService.get(`/assets/listbylocation/${locationId}`);
  }

  async lookup(assetsIds: string[]) {
    const body = {
      assetsIds: assetsIds
    };
    return await this.apiService.post(`/assets/lookup`, body);
  }

  async UpdateAssetIsActiveStatus(assetId: string, is_active: boolean) {
    const body = {
      isActive: is_active
    }
    return this.apiService.patch(`/assets/${assetId}/update-active-status`, body)
  }

  async relocateAsset(assetId: string, locationId: string) {
    const body = {
      locationId: locationId
    }
    return this.apiService.patch(`/assets/${assetId}/relocate`, body)
  }

  async getAssetsExport(locationId: string, search: string, fileType: string, is_active: number) {
    const body = {
      LocationId: locationId == '0' || !locationId ? null : locationId,
      Search: search,
      FileType: fileType,
      IsActive: is_active.toString()
    };
    return await this.apiService.post('/assets/export', body);
  }

  async getRentalExport(locationId: string, search: string, fileType: string) {
    const body = {
      LocationId: locationId == "0" ? null : locationId,
      Search: search,
      FileType: fileType
    };
    return await this.apiService.post('/assets/rental-export', body);
  }

  async getAssetsRental(limit: number, offset: number, search: string, order: TableSort | null, locationId: string) {
    const body = {
      offset: offset,
      limit: limit,
      search: search,
      sort: JSON.stringify(order),
      locationId: locationId == '0' || !locationId ? null : locationId
    };
    return await this.apiService.post('/assets/rental', body);
  }

  async getRentalServiceHistory(id: string) {
    return this.apiService.get(`/assets/${id}/rental-service-history`);
  }

  async getAssetsByLookup(locationId: string, lookup: string) {
    const body = {
      locationId: locationId,
      lookup: lookup
    }
    return await this.apiService.post(`/assets/lookup-assets`, body);
  }
}
